import type { DeteriorationListSortField, SortPreference } from './sortPreferences';

export type DeteriorationListSortableRow = {
  equipmentName: string;
  currentRate: number | null;
  importanceLevel: number;
};

const compareNullableNumbers = (left: number | null, right: number | null, order: 'asc' | 'desc'): number => {
  if (left === null && right === null) {
    return 0;
  }
  if (left === null) {
    return 1;
  }
  if (right === null) {
    return -1;
  }
  return order === 'asc' ? left - right : right - left;
};

const toHealthIndex = (currentRate: number | null): number | null => {
  if (currentRate === null) {
    return null;
  }
  return 100 - currentRate;
};

export const sortDeteriorationRows = <TRow extends DeteriorationListSortableRow>(
  rows: TRow[],
  preference: SortPreference<DeteriorationListSortField>,
): TRow[] => {
  return [...rows].sort((left, right) => {
    let result = 0;

    switch (preference.field) {
      case 'health':
        result = compareNullableNumbers(
          toHealthIndex(left.currentRate),
          toHealthIndex(right.currentRate),
          preference.order,
        );
        break;
      case 'importanceLevel':
        result = compareNullableNumbers(left.importanceLevel, right.importanceLevel, preference.order);
        break;
      case 'equipmentName':
      default: {
        const compared = left.equipmentName.localeCompare(right.equipmentName, 'ja');
        result = preference.order === 'asc' ? compared : -compared;
        break;
      }
    }

    if (result !== 0) {
      return result;
    }

    return left.equipmentName.localeCompare(right.equipmentName, 'ja');
  });
};
